import type { SolveTier } from "./solver";

/**
 * What each solving tier asks of the player, in the site's own voice. The label
 * sits beside the clock where a glance answers "how hard is today's thinking",
 * and the sentence behind it says what that label actually means — a tier number
 * without a definition is a badge, not information.
 */

export const SOLVE_TIERS: Readonly<Record<SolveTier, { label: string; description: string }>> = {
  1: {
    label: "Line by line",
    description: "Every square can be deduced by reading one row or column at a time.",
  },
  2: {
    label: "Careful corners",
    description:
      "Some squares need one tried arrangement that quickly contradicts itself — the corner-reading technique.",
  },
  3: {
    label: "Look-ahead",
    description: "Progress needs holding one assumption inside another before a square is certain.",
  },
  4: {
    label: "Deep chains",
    description: "The deepest grids: some squares only fall after long chains of elimination.",
  },
};

export function solveTierLabel(tier: SolveTier): string {
  return SOLVE_TIERS[tier].label;
}
